import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/dangol-logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-top">
          <div className="footer-brand">
            <img src={logo} alt="Dangol" className="footer-logo" />
            <p className="footer-tagline">An app for the community your shop already is.</p>
          </div>

          <nav className="footer-nav">
            <div className="footer-nav-group">
              <span className="footer-nav-label">Product</span>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><a href="/#features">Features</a></li>
                <li><a href="/#contact">Become a partner</a></li>
              </ul>
            </div>

            <div className="footer-nav-group">
              <span className="footer-nav-label">Company</span>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><a href="mailto:customersupport@dangolapp.com">Contact</a></li>
              </ul>
            </div>

            <div className="footer-nav-group">
              <span className="footer-nav-label">Legal</span>
              <ul>
                <li><Link to="/privacy">Privacy</Link></li>
                <li><Link to="/terms">Terms</Link></li>
                <li><Link to="/customersupport">Support</Link></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="footer-bottom">
          <span className="footer-copyright">© {new Date().getFullYear()} Dangol</span>
          <span className="footer-location">Made in Chicago & Ann Arbor</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
